// themes.js (или где ты хранишь createTheme)
import { createTheme } from "@mui/material/styles";

// 1. Твоя ОБЫЧНАЯ (светлая) тема
export const normalTheme = createTheme({
  palette: {
    mode: "light", // Светлый режим
    primary: {
      main: "#191970", // Тот самый твой темно-синий
    },
    secondary: {
      main: "#4169E1", // Твой второй синий (из hover'а поиска)
    },
    text: {
      primary: "#212121", // Основной текст (вместо "black")
      secondary: "#555", // Вторичный текст
    },
    background: {
      default: "#FFFFFF", // Белый фон
      paper: "#f5f5f5", // Фон "бумаги" (карточек, меню)
    },
  },
  typography: {
    // тут можно оставить настройки шрифта
  },
});

// 2. Твоя ДОСТУПНАЯ (темная/контрастная) тема
export const accessibleTheme = createTheme({
  palette: {
    mode: "dark", // 👈 Главное!
    primary: {
      // В темной теме основной "акцентный" цвет лучше сделать ярким
      main: "#FFFF00", // Ярко-желтый (отлично видно на черном)
      // или оставь синий, если он используется только как фон кнопок с белым текстом
      // main: '#191970',
    },
    secondary: {
      main: "#FFD700", // Золотой/желтый
    },
    text: {
      // В темном режиме текст должен стать светлым
      primary: "#FFFFFF", // 👈 Вместо "black" теперь белый
      secondary: "#DDDDDD", // Светло-серый
    },
    background: {
      default: "#000000", // 👈 Черный фон
      paper: "#1a1a1a", // Чуть светлее черного для меню
    },
  },
  typography: {
    // В этой теме мы увеличиваем шрифт
    fontSize: 18, // Базовый шрифт больше (по умолчанию 14-16)
    // (MUI автоматически увеличит h1, h2, body1 и т.д. пропорционально)
  },
});
